<template>
    <div>
        <!-- <form class="form filters">
            <div class="row">
                <div class="col-12">
                    <div class="form__item">
                        <i class="form__icon icons icon-user"></i>
                        <input class="form__input--text" v-model="nameFilter" label="name" :class="{ 'has-value': !!nameFilter }" />
                        <label class="form__label">{{$t('forms.common.labels.name')}}</label>
                    </div>
                </div>
            </div>
        </form> -->
        <div class="table__responsive">
            <table class="table--clickable_rows">
                <thead v-if="!loadingEvaluations  && pendingEvaluations.length">
                    <tr>
                        <th>{{$t('evaluations.student')}}</th>
                        <th>{{$t('evaluations.diploma')}}</th>
                        <th>{{$t('evaluations.qualification')}}</th>
                        <th>{{$t('evaluations.role')}}</th>
                        <th class="table__cell--icon"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="loadingEvaluations" :key="'loading'" class="table--loading">
                        <td colspan="5">
                            <div class="spinner"></div>
                            <div class="text-center loading_text">{{$t('pending_evaluations.table.loading')}}</div>
                        </td>
                    </tr>
                    <tr v-if="!loadingEvaluations && !pendingEvaluations.length" :key="'no-evaluations'" class="table--empty">
                        <td colspan="5">
                            <div class="text-center">{{$t('pending_evaluations.table.no_evaluations')}}</div>
                        </td>
                    </tr>
                    <tr v-for="(evaluation, index) in pendingEvaluations" :key="`${evaluation.id}_${index}`" @click="navigateToEvaluation(evaluation)">
                        <td>{{ evaluation.student.name }}</td>
                        <td>{{ evaluation.diploma.title }}</td>
                        <td>{{ evaluation.work_process.title }}</td>
                        <td>{{ getEvaluationName(evaluation.evaluator_role.name) }}</td>
                        <td><span @click="navigateToEvaluation(evaluation)" v-tooltip.right="$t('pending_evaluations.table.view')" class="table__icon icons icon-eye"></span></td>
                    </tr>

                    <tr class="table__navigation" v-if="pendingEvaluationsMeta && pendingEvaluationsMeta.last_page > 1">
                        <td colspan="5">
                            <pagination :meta="pendingEvaluationsMeta" @goToPage="goToPage"/>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { Component, Watch } from 'vue-property-decorator';
    import { GET_PENDING_EVALUATIONS } from '@/store/modules/pending-evaluations';
    const comparify = text => (text || '').replace(/[^a-zA-Z]/g, '').toLowerCase();

    @Component({})
    export default class PendingEvaluationsTable extends Vue {
        name = 'evaluation-students-table';
        nameFilter = null;
        mounted() {
            this.nameFilter = '';

            this.$store.dispatch(GET_PENDING_EVALUATIONS, {});
        }

        get pendingEvaluations() {
            return this.$store.state.pending_evaluations.pendingEvaluations;
        }

        get pendingEvaluationsMeta() {
            return this.$store.state.pending_evaluations.pendingEvaluationsMeta;
        }

        get loadingEvaluations() {
            return this.$store.state.pending_evaluations.loading;
        }

        // @Watch('nameFilter', { })
        // filterByName(name) {
        //     if (!name) return;
        //     this.$store.dispatch(GET_PENDING_EVALUATIONS, { params: { q: name, page: 1 }});
        // }

        getEvaluationName(name) {
            if (name === 'teacher') return 'Leraar';
            if (name === 'mentor') return 'Begeleider';
            if (name === 'coach') return 'Coach';
            if (name === 'recipient') return 'Zorgvrager';
            if (name === 'student') return 'Mijn oordeel';
            if (name === 'other_student') return 'Medestudent';
            return name;
        }

        goToPage(pageNo) {
            this.$store.dispatch(GET_PENDING_EVALUATIONS, { params: { page: pageNo }});
        }

        navigateToEvaluation(evaluation) {
            this.$router.push({
                name: 'evaluation-student',
                params: {
                    user_id: evaluation.student.id,
                    diploma_id: evaluation.diploma.diploma_id,
                    work_process_id: evaluation.work_process.work_process_id,
                    evaluation_id: evaluation.id
                }
            });
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/tables/pending-evaluations/PendingEvaluationsTable.vue